import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Core
import CircularProgress from '@eig-builder/core-ui/CircularProgress'
import Typography from '@eig-builder/core-ui/Typography'
import TextField from '@eig-builder/core-ui/TextField'
import InputAdornment from '@eig-builder/core-ui/InputAdornment'
import { withStyles } from '@eig-builder/core-ui/styles'

// Other
import classNames from 'classnames'
import Text from 'localize'
import './lang'

const styles = {
  inputBaseOverride: {
    color: 'inherit'
  }
}

class CartSummaryComponent extends Component {
  static propTypes = {
    show: PropTypes.bool,
    retrieving: PropTypes.bool,
    isValid: PropTypes.bool,
    onChange: PropTypes.func,
    discountCode: PropTypes.string,
    error: PropTypes.string,
    hasResponse: PropTypes.bool,
    classes: PropTypes.object
  }

  state = { showInput: false }

  _toggleShowInput = () => {
    const { showInput } = this.state

    this.setState({
      showInput: !showInput
    })
  }

  _clearDiscountCode = () => {
    const { onChange = () => {} } = this.props

    this._toggleShowInput()

    onChange('')
  }

  _onChange = (event) => {
    const { target = {} } = event
    const { value = '' } = target

    const { onChange = () => {} } = this.props

    onChange(value)
  }

  render () {
    const { show = false, classes } = this.props

    if (!show) {
      return (null)
    }

    const { showInput = false } = this.state

    if (!showInput) {
      return (
        <div id='discount-button'>
          <Typography
            variant='link2'
            onClick={this._toggleShowInput}
          >
            <Text
              className='discount-code'
              message='modules.cart.components.discount.enter'
            />
          </Typography>
        </div>
      )
    }

    const { retrieving = false, isValid = false, discountCode = '', error = '', hasResponse = false } = this.props
    const cancelDiscountClasses = classNames('discount-code', { 'd-none': isValid })
    const clearDiscountClasses = classNames('discount-code', { 'd-none': !isValid })

    return (
      <>
        <div className='discount-enter-box'>
          <TextField
            variant='outlined'
            onChange={this._onChange}
            value={discountCode}
            InputProps={{
              classes: {
                root: classes.inputBaseOverride
              },
              endAdornment: retrieving && <InputAdornment position='end'>
                <CircularProgress
                  size={30}
                  align='none'
                  wrapperStyle={{ height: 'auto' }}
                />
              </InputAdornment>
            }}
          />
          <Text
            className={cancelDiscountClasses}
            onClick={this._clearDiscountCode}
            message='modules.cart.components.discount.cancel'
          />
          <Text
            className={clearDiscountClasses}
            onClick={this._clearDiscountCode}
            message='modules.cart.components.discount.clear'
          />
          {
            discountCode && !isValid && !retrieving && hasResponse &&
              <Text className='discount-span discount-invalid' message='modules.cart.components.discount.invalid' />
          }
          {
            discountCode && !retrieving && error &&
              <Text className='discount-span discount-invalid' message={`modules.cart.components.discount.errors.${error}`} />
          }

        </div>
      </>
    )
  }
}

export default withStyles(styles)(CartSummaryComponent)
